<!-- <body> -->
<!-- <app-outing-header></app-outing-header> -->
<!-- <div class="sideBar"></div> -->
<div class="contentContainer">
    <div class="titleContainer" *ngIf="!overallList">
        <span class="titleFaculty">Faculty Tracking Dashboard <span>(Today: {{ selectedDate | date:'dd/MM/yyyy'
                }})</span></span>

        <div class="rightSection" *ngIf="!showDate">
            <mat-form-field appearance="outline" class="date-field">
                <!-- <mat-label>Date</mat-label> -->
                <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate"
                    (dateChange)="onDateSelected($event)" placeholder="DD/MM/YYYY">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <button class="viewButton" (click)="openfacultyTrackDialog()">View Details</button>
    </div>
    <div class=" dataContainer" *ngIf="!overallList">
        <span class="subDataContainer box_shadow" *ngFor="let item of facultyOverallData" (click)="onStatusClick(item)">
            <div class="imageContainer">
                <img class="imgIcon" [src]="getIcon(item.statusName)" alt="">
                <div class="flex_col">
                    <span class="countFont">{{ item.count }}</span>
                    <span>{{ item.statusName |uppercase }}</span>
                </div>
            </div>
            <div style="margin-left: 10%;margin-bottom: 10px;">
                <div style="display: flex; height: 6px; width: 90%; border-radius: 10px; background-color: #D9D9D9;">
                    <div [style.backgroundColor]="getBarColor(item.statusName)" [style.width.%]="item.percentage"
                        style="border-radius: 10px;"></div>
                </div>
            </div>
        </span>

    </div>
    <div class="tableContentContainer">
        <div class="tabletitleContainer">
            <div class="breadcrumbs">
                <span class="titleFont" style="color: #555555; font-size: 16px;cursor: pointer;"
                    (click)="setHeader('overall')">
                    Overall View
                </span>
                <span class="titleFont" style="color: #555555; font-size: 16px;cursor: pointer;"
                    (click)="setHeader('los')">
                    {{ los ? '/' + los : '' }}
                </span>
                <span class="titleFont" style="color: #555555; font-size: 16px;cursor: pointer;"
                    (click)="setHeader('state')">
                    {{ stateName ? '/' + stateName : '' }}
                </span>
                <span class="titleFont" style="color: #555555; font-size: 16px;cursor: pointer;"
                    (click)="setHeader('city')">
                    {{ cityName ? '/' + cityName : '' }}
                </span>
                <span class="titleFont" style="color: #555555; font-size: 16px;cursor: pointer;"
                    (click)="setHeader('campus')">
                    {{ campusName ? '/' + campusName : '' }}
                </span>
            </div>
            <div style="display: flex; gap: 15px;width: 35%;">
                <button class="filterBtn" *ngIf="!showFilter" (click)="openFilterDialog()">
                    <!-- <img src="assets/icons/filter.svg" class="filterIcon" /> -->
                    <svg width="11" class="filterIcon" height="12" viewBox="0 0 11 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.17741 12H4.05263V5.9457L0 0.9457V0H11V0.9403L7.14035 5.9403V9.96568L5.17741 12ZM4.82456 11.2H4.85768L6.36842 9.63433V5.6597L10.1198 0.8H0.890132L4.82456 5.6543V11.2Z"
                            fill="#555555" />
                    </svg>
                    <span>Filter</span>
                </button>


                <div class="rightSection" *ngIf="!showDate">
                    <mat-form-field appearance="outline" class="date-field">
                        <!-- <mat-label>Date</mat-label> -->
                        <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate"
                            (dateChange)="onDateSelected($event)" placeholder="DD/MM/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <button *ngIf="!showLocation" (click)="viewLocation()" class="viewButtonlocation">View Location</button>
            </div>
        </div>
        <div class="tableContainer" *ngIf="!overall">

            <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." />
            <ag-grid-angular style="width: 98%; height:75%; overflow: auto; margin-left: 1%;max-height: 84%;"
                [rowData]="rowData" [pinnedTopRowData]="pinnedTopRowData" [columnDefs]="colDefs"
                [defaultColDef]="defaultColDef" [quickFilterText]="quickFilter"
                [overlayNoRowsTemplate]="overlayNoRowsTemplate" />
        </div>
        <div *ngIf="!section">
            <div class="stats-bar" *ngIf="selectionData">
                <div class="stat-item">
                    <div class="icon-circle purple">
                        <span class="material-icons">meeting_room</span>
                    </div>
                    <div class="stat-text">
                        <span class="label">Total Section: </span>
                        <span class="value">{{selectionData.totalSections}}</span>
                    </div>
                </div>
                <div class="stat-item">
                    <div class="icon-circle blue">
                        <span class="material-icons">group</span>
                    </div>
                    <div class="stat-text">
                        <span class="label">Total Staff: </span>
                        <span class="value">{{selectionData.totalEmployees}}</span>
                    </div>
                </div>
                <div class="stat-item">
                    <div class="icon-circle orange">
                        <span class="material-icons">school</span>
                    </div>
                    <div class="stat-text">
                        <span class="label">Teaching: </span>
                        <span class="value">{{selectionData.teachingEmployees}}</span>
                    </div>
                </div>
                <div class="stat-item">
                    <div class="icon-circle cyan">
                        <span class="material-icons">person</span>
                    </div>
                    <div class="stat-text">
                        <span class="label">Non Teaching: </span>
                        <span class="value">{{selectionData.nonTeachingEmployees}}</span>
                    </div>
                </div>
            </div>
            <div class="tableContainerSecond">
                 <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." />
                 
                <ag-grid-angular style="width: 98%; height:90%; overflow: auto; margin-left: 1%;max-height: 90%;"
                    [gridOptions]="gridOptions" [rowData]="rowData" [pinnedTopRowData]="pinnedTopRowData"
                    [columnDefs]="colDefs" [defaultColDef]="defaultColDef" [quickFilterText]="quickFilter"
                    [overlayNoRowsTemplate]="overlayNoRowsTemplate" (gridReady)="onGridReady($event)" />
            </div>

        </div>
    </div>
</div>
<!-- </body> -->


<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>